const eventNames = {
  RECIPIENTCOUNT: 'recipientCount',
  DUPLICATECOUNT: 'duplicateCount',
  SHOWMODAL: 'showModal'
}

export default eventNames;
